import { userRoleEnum } from "./enums";

export type ResourceAllocationApiView = "admin" | "manager";

export function getResourceAllocationApiView(baseRole?: string | null): ResourceAllocationApiView {
  const workContext = localStorage.getItem("workContext") ?? baseRole ?? "";
  return workContext === userRoleEnum.Admin ? "admin" : "manager";
}

export function isResourceAllocationReadOnly(
  readOnlyModeFromApi?: boolean,
  baseRole?: string | null
): boolean {
  return readOnlyModeFromApi === true || getResourceAllocationApiView(baseRole) === "admin";
}
